var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXbutton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.024,
    height: 19.025,
    viewBox: "0 0 19.024 19.025",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14388",
    "data-name": "Group 14388",
    transform: "translate(-1242.639 -287.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46391",
    "data-name": "Path 46391",
    d: "M0,0H24.9",
    transform: "translate(1243.347 288.499) rotate(45)",
    fill: "none",
    stroke: "#b1b1b1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46392",
    "data-name": "Path 46392",
    d: "M0,0H24.9",
    transform: "translate(1260.957 288.501) rotate(135)",
    fill: "none",
    stroke: "#b1b1b1",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXbutton);
export default __webpack_public_path__ + "static/media/xbutton.7cf7c4bb87e1cac06e8b5fdfd1d25f03.svg";
export { ForwardRef as ReactComponent };